import { render, staticRenderFns } from "./DashboardEvent.vue?vue&type=template&id=57db377e&lang=pug&"
import script from "./DashboardEvent.vue?vue&type=script&lang=js&"
export * from "./DashboardEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports